/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  AddExtraServerInfoRequest,
  ExtraGlobalFilterRequest,
  ExtraGlobalFilterResponse,
  ExtraServerListResponse,
  ExtraServerResponse,
  GetV8ExtraServerGetExtraTypeParams,
  GetV8ExtraServerGlobalFilterGetParams,
  ModifyExtraServerInfoRequest,
  PatchV8ExtraServerDeleteParams,
  PrometheusStatusRequest,
  ResultResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 서버 정보 저장
 */
export const postV8ExtraServer = (
  addExtraServerInfoRequest: MaybeRef<AddExtraServerInfoRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  addExtraServerInfoRequest = unref(addExtraServerInfoRequest);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v8/extra-server`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addExtraServerInfoRequest,
      signal,
    },
    options,
  );
};

export const getPostV8ExtraServerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8ExtraServer>>,
    TError,
    { data: BodyType<AddExtraServerInfoRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8ExtraServer>>,
  TError,
  { data: BodyType<AddExtraServerInfoRequest> },
  TContext
> => {
  const mutationKey = ['postV8ExtraServer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8ExtraServer>>,
    { data: BodyType<AddExtraServerInfoRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8ExtraServer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8ExtraServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8ExtraServer>>
>;
export type PostV8ExtraServerMutationBody = BodyType<AddExtraServerInfoRequest>;
export type PostV8ExtraServerMutationError = ErrorType<unknown>;

/**
 * @summary 서버 정보 저장
 */
export const usePostV8ExtraServer = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8ExtraServer>>,
      TError,
      { data: BodyType<AddExtraServerInfoRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8ExtraServer>>,
  TError,
  { data: BodyType<AddExtraServerInfoRequest> },
  TContext
> => {
  const mutationOptions = getPostV8ExtraServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 서버 정보 수정
 */
export const patchV8ExtraServer = (
  modifyExtraServerInfoRequest: MaybeRef<ModifyExtraServerInfoRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  modifyExtraServerInfoRequest = unref(modifyExtraServerInfoRequest);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v8/extra-server`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: modifyExtraServerInfoRequest,
    },
    options,
  );
};

export const getPatchV8ExtraServerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV8ExtraServer>>,
    TError,
    { data: BodyType<ModifyExtraServerInfoRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV8ExtraServer>>,
  TError,
  { data: BodyType<ModifyExtraServerInfoRequest> },
  TContext
> => {
  const mutationKey = ['patchV8ExtraServer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV8ExtraServer>>,
    { data: BodyType<ModifyExtraServerInfoRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return patchV8ExtraServer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV8ExtraServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV8ExtraServer>>
>;
export type PatchV8ExtraServerMutationBody = BodyType<ModifyExtraServerInfoRequest>;
export type PatchV8ExtraServerMutationError = ErrorType<unknown>;

/**
 * @summary 서버 정보 수정
 */
export const usePatchV8ExtraServer = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV8ExtraServer>>,
      TError,
      { data: BodyType<ModifyExtraServerInfoRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV8ExtraServer>>,
  TError,
  { data: BodyType<ModifyExtraServerInfoRequest> },
  TContext
> => {
  const mutationOptions = getPatchV8ExtraServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 서버 정보 삭제
 */
export const patchV8ExtraServerDelete = (
  params: MaybeRef<PatchV8ExtraServerDeleteParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    { url: `/api/v8/extra-server/delete`, method: 'PATCH', params: unref(params) },
    options,
  );
};

export const getPatchV8ExtraServerDeleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV8ExtraServerDelete>>,
    TError,
    { params: PatchV8ExtraServerDeleteParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV8ExtraServerDelete>>,
  TError,
  { params: PatchV8ExtraServerDeleteParams },
  TContext
> => {
  const mutationKey = ['patchV8ExtraServerDelete'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV8ExtraServerDelete>>,
    { params: PatchV8ExtraServerDeleteParams }
  > = (props) => {
    const { params } = props ?? {};

    return patchV8ExtraServerDelete(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV8ExtraServerDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV8ExtraServerDelete>>
>;

export type PatchV8ExtraServerDeleteMutationError = ErrorType<unknown>;

/**
 * @summary 서버 정보 삭제
 */
export const usePatchV8ExtraServerDelete = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV8ExtraServerDelete>>,
      TError,
      { params: PatchV8ExtraServerDeleteParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV8ExtraServerDelete>>,
  TError,
  { params: PatchV8ExtraServerDeleteParams },
  TContext
> => {
  const mutationOptions = getPatchV8ExtraServerDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 서버 정보 리스트
 */
export const getV8ExtraServerGet = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ExtraServerListResponse>(
    { url: `/api/v8/extra-server/get`, method: 'GET', signal },
    options,
  );
};

export const getGetV8ExtraServerGetQueryKey = () => {
  return ['api', 'v8', 'extra-server', 'get'] as const;
};

export const getGetV8ExtraServerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ExtraServerGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8ExtraServerGet>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ExtraServerGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ExtraServerGet>>> = ({ signal }) =>
    getV8ExtraServerGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ExtraServerGet>>,
    TError,
    TData
  >;
};

export type GetV8ExtraServerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ExtraServerGet>>
>;
export type GetV8ExtraServerGetQueryError = ErrorType<unknown>;

/**
 * @summary 서버 정보 리스트
 */

export function useGetV8ExtraServerGet<
  TData = Awaited<ReturnType<typeof getV8ExtraServerGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ExtraServerGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ExtraServerGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 서버 정보 ( 타입 )
 */
export const getV8ExtraServerGetExtraType = (
  params: MaybeRef<GetV8ExtraServerGetExtraTypeParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ExtraServerListResponse>(
    { url: `/api/v8/extra-server/get/extraType`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8ExtraServerGetExtraTypeQueryKey = (
  params?: MaybeRef<GetV8ExtraServerGetExtraTypeParams>,
) => {
  return ['api', 'v8', 'extra-server', 'get', 'extraType', ...(params ? [params] : [])] as const;
};

export const getGetV8ExtraServerGetExtraTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ExtraServerGetExtraType>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ExtraServerGetExtraTypeParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ExtraServerGetExtraType>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ExtraServerGetExtraTypeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ExtraServerGetExtraType>>> = ({
    signal,
  }) => getV8ExtraServerGetExtraType(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ExtraServerGetExtraType>>,
    TError,
    TData
  >;
};

export type GetV8ExtraServerGetExtraTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ExtraServerGetExtraType>>
>;
export type GetV8ExtraServerGetExtraTypeQueryError = ErrorType<unknown>;

/**
 * @summary 서버 정보 ( 타입 )
 */

export function useGetV8ExtraServerGetExtraType<
  TData = Awaited<ReturnType<typeof getV8ExtraServerGetExtraType>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ExtraServerGetExtraTypeParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ExtraServerGetExtraType>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ExtraServerGetExtraTypeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 서버 정보 ( 단일 )
 */
export const getV8ExtraServerGetByExtraId = (
  extraId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  extraId = unref(extraId);

  return customAxiosInstance<ExtraServerResponse>(
    { url: `/api/v8/extra-server/get/${extraId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV8ExtraServerGetByExtraIdQueryKey = (extraId?: MaybeRef<string>) => {
  return ['api', 'v8', 'extra-server', 'get', extraId] as const;
};

export const getGetV8ExtraServerGetByExtraIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ExtraServerGetByExtraId>>,
  TError = ErrorType<unknown>,
>(
  extraId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ExtraServerGetByExtraId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ExtraServerGetByExtraIdQueryKey(extraId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ExtraServerGetByExtraId>>> = ({
    signal,
  }) => getV8ExtraServerGetByExtraId(extraId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(extraId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV8ExtraServerGetByExtraId>>, TError, TData>;
};

export type GetV8ExtraServerGetByExtraIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ExtraServerGetByExtraId>>
>;
export type GetV8ExtraServerGetByExtraIdQueryError = ErrorType<unknown>;

/**
 * @summary 서버 정보 ( 단일 )
 */

export function useGetV8ExtraServerGetByExtraId<
  TData = Awaited<ReturnType<typeof getV8ExtraServerGetByExtraId>>,
  TError = ErrorType<unknown>,
>(
  extraId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ExtraServerGetByExtraId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ExtraServerGetByExtraIdQueryOptions(extraId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * extra 글로벌 변수 추가
 * @summary addOrUpdateExtraGlobalFilter
 */
export const postV8ExtraServerGlobalFilter = (
  extraGlobalFilterRequest: MaybeRef<ExtraGlobalFilterRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  extraGlobalFilterRequest = unref(extraGlobalFilterRequest);

  return customAxiosInstance<string>(
    {
      url: `/api/v8/extra-server/global-filter`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: extraGlobalFilterRequest,
      signal,
    },
    options,
  );
};

export const getPostV8ExtraServerGlobalFilterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8ExtraServerGlobalFilter>>,
    TError,
    { data: BodyType<ExtraGlobalFilterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8ExtraServerGlobalFilter>>,
  TError,
  { data: BodyType<ExtraGlobalFilterRequest> },
  TContext
> => {
  const mutationKey = ['postV8ExtraServerGlobalFilter'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8ExtraServerGlobalFilter>>,
    { data: BodyType<ExtraGlobalFilterRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8ExtraServerGlobalFilter(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8ExtraServerGlobalFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8ExtraServerGlobalFilter>>
>;
export type PostV8ExtraServerGlobalFilterMutationBody = BodyType<ExtraGlobalFilterRequest>;
export type PostV8ExtraServerGlobalFilterMutationError = ErrorType<unknown>;

/**
 * @summary addOrUpdateExtraGlobalFilter
 */
export const usePostV8ExtraServerGlobalFilter = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8ExtraServerGlobalFilter>>,
      TError,
      { data: BodyType<ExtraGlobalFilterRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8ExtraServerGlobalFilter>>,
  TError,
  { data: BodyType<ExtraGlobalFilterRequest> },
  TContext
> => {
  const mutationOptions = getPostV8ExtraServerGlobalFilterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * extra 글로벌 변수 조회 리스트
 * @summary getExtraGlobalFilters
 */
export const getV8ExtraServerGlobalFilterGet = (
  params: MaybeRef<GetV8ExtraServerGlobalFilterGetParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ExtraGlobalFilterResponse>(
    { url: `/api/v8/extra-server/global-filter/get`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8ExtraServerGlobalFilterGetQueryKey = (
  params?: MaybeRef<GetV8ExtraServerGlobalFilterGetParams>,
) => {
  return [
    'api',
    'v8',
    'extra-server',
    'global-filter',
    'get',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8ExtraServerGlobalFilterGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ExtraServerGlobalFilterGet>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ExtraServerGlobalFilterGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ExtraServerGlobalFilterGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ExtraServerGlobalFilterGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ExtraServerGlobalFilterGet>>> = ({
    signal,
  }) => getV8ExtraServerGlobalFilterGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ExtraServerGlobalFilterGet>>,
    TError,
    TData
  >;
};

export type GetV8ExtraServerGlobalFilterGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ExtraServerGlobalFilterGet>>
>;
export type GetV8ExtraServerGlobalFilterGetQueryError = ErrorType<unknown>;

/**
 * @summary getExtraGlobalFilters
 */

export function useGetV8ExtraServerGlobalFilterGet<
  TData = Awaited<ReturnType<typeof getV8ExtraServerGlobalFilterGet>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ExtraServerGlobalFilterGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ExtraServerGlobalFilterGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ExtraServerGlobalFilterGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 서버 연결 테스트
 */
export const postV8ExtraServerTest = (
  prometheusStatusRequest: MaybeRef<PrometheusStatusRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  prometheusStatusRequest = unref(prometheusStatusRequest);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v8/extra-server/test`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: prometheusStatusRequest,
      signal,
    },
    options,
  );
};

export const getPostV8ExtraServerTestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8ExtraServerTest>>,
    TError,
    { data: BodyType<PrometheusStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8ExtraServerTest>>,
  TError,
  { data: BodyType<PrometheusStatusRequest> },
  TContext
> => {
  const mutationKey = ['postV8ExtraServerTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8ExtraServerTest>>,
    { data: BodyType<PrometheusStatusRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8ExtraServerTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8ExtraServerTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8ExtraServerTest>>
>;
export type PostV8ExtraServerTestMutationBody = BodyType<PrometheusStatusRequest>;
export type PostV8ExtraServerTestMutationError = ErrorType<unknown>;

/**
 * @summary 서버 연결 테스트
 */
export const usePostV8ExtraServerTest = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8ExtraServerTest>>,
      TError,
      { data: BodyType<PrometheusStatusRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8ExtraServerTest>>,
  TError,
  { data: BodyType<PrometheusStatusRequest> },
  TContext
> => {
  const mutationOptions = getPostV8ExtraServerTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
